import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Down from '../views/Down.vue'
import Video from '../views/Video.vue'
import AppDownload from '../views/AppDownload.vue'
import VideoPlayer from '../views/VideoPlayer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: "应用导航首页" }
  },
  {
    path: "/video",
    name: "video",
    component: Video,
    meta: { title: "视频页面" }
  },
  {
    path: "/video/play/:id",
    name: "videoPlay",
    component: VideoPlayer,
    meta: { title: "视频播放" }
  },
  {
    path: "/download",
    name: "download",
    component: Down,
    meta: { title: "应用导航下载页" }
  },
  {
    path: "/app-download",
    name: "appDownload",
    component: AppDownload,
    meta: { title: "导航盒子下载" }
  }
]

const router = new VueRouter({
  routes
})

export default router
